<div class="container h-100 canvas-page">
    <div class="row h-100 justify-content-center align-items-center VerticalMargin">
        <div class="card SmallForm rounded col-12 col-lg-9 canvas-panel">
            <div class="card-header MyCardHeader rounded-top">
                <div class="input-group">
                    <div class="form-control MyCardTitle">
                        <h2 class="Head">
                            {{ 'DELETE_ACCOUNT' | translate }}</h2>
                    </div>
                </div>
            </div>
            <div class="card-body MyCardBody rounded-bottom">
                <div class="text-center" style="font-weight: 600">{{ 'THIS_ACTION_WILL_DO_THE_FOLLOWING' | translate }}</div>
                <br />
                <ul>
                    <li>{{ 'PERMANENTLY_DELETE_YOUR_ACCOUNT' | translate }}</li>
                    <li>{{ 'PERMANENTLY_DELETE_ALL_YOUR_PERSONAL_INFORMATION_AND_CHECKIN_DETAILS' | translate }}</li>
                    <li>{{ 'YOU_WILL_NOT_BE_ABLE_TO_LOGIN_ANYMORE' | translate }}</li>
                    <li>{{ 'YOU_CAN_STILL_USE_THE_APP_ANONYMOUSLY' | translate }}</li>
                </ul>
                <br>
                <div class="text-center" style="font-weight: 600">{{ 'INSTRUCTIONS_TO_DELETE_ACCOUNT' | translate }}</div>
                <br />
                <ul>
                    <li>{{ 'OPEN_YOUR_PROFILE_CLICK_BELOW' | translate }}</li>
                    <br />
                    <div class="col-10">
                        <button class="btn btn-primary btn-block" [routerLink]="['/', tenantService.getTenant(), 'myprofile']" [queryParams]="{delete:'true'}" type="button">
                            <span> {{ 'OPEN_PROFILE_7234213' | translate }}</span>
                        </button>
                    </div>
                    <br />
                    <li>{{ 'IF_PROMPT_LOGIN_TO_YOUR_ACCOUNT' | translate }}</li>
                    <li>{{ 'UNDER_ACCOUNT_SETTINGS_CLICK_DELETE_ACCOUNT' | translate }}</li>
                    <li>{{ 'ACCOUNT_DELETION_CHOICE_QUESTION' | translate }}</li>
                    <li>{{ 'ACCOUNT_DELETION_BACKGROUND_DETAIL' | translate }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
